import { BaseWidgetProps } from 'consumer-page-widgets/WidgetUtils/BaseWidgetProps';
import { consumer } from '@tock/coretypes';
import {
  rowLayoutWidgetContainer,
  rowLayoutWidgetItem,
} from 'consumer-page-widgets/RowLayoutWidget/rowLayoutWidgetCssDefs';
import AvatarCardLinkWidget from 'consumer-page-widgets/AvatarCardLinkWidget/AvatarCardLinkWidget';
import CardLinkWidget from 'consumer-page-widgets/CardLinkWidget/CardLinkWidget';
import React from 'react';
import WidgetLayoutContainer from 'consumer-page-widgets/WidgetUtils/WidgetLayoutContainer';

export interface ValidForRowLayoutWidgetProps {
  standalone?: boolean;
}

interface RowLayoutWidgetProps extends BaseWidgetProps {
  widget: consumer.IRowLayoutWidget;
}

export function getDisplayComponentForRowLayoutWidgetItem(
  widgetItem: consumer.IRowLayoutWidgetItem,
  widgetInfo?: consumer.IWidgetInfo,
  pageWidgetListIndex?: number
) {
  if (widgetItem.cardLinkWidget) {
    return (
      <CardLinkWidget
        standalone={false}
        widget={widgetItem.cardLinkWidget}
        widgetInfo={widgetInfo}
        pageWidgetListIndex={pageWidgetListIndex}
      />
    );
  }
  if (widgetItem.avatarCardLinkWidget) {
    return (
      <AvatarCardLinkWidget
        standalone={false}
        widget={widgetItem.avatarCardLinkWidget}
        widgetInfo={widgetInfo}
        pageWidgetListIndex={pageWidgetListIndex}
      />
    );
  }
  return null;
}

const RowLayoutWidget: React.FunctionComponent<RowLayoutWidgetProps> = ({
  widget,
  widgetInfo,
  pageWidgetListIndex,
}) => {
  return (
    <WidgetLayoutContainer>
      <div css={rowLayoutWidgetContainer}>
        {widget.rowLayoutWidgetItem?.map((item, index) =>
          item.widthPercentage ? (
            <div key={index} css={rowLayoutWidgetItem(item.widthPercentage)}>
              {getDisplayComponentForRowLayoutWidgetItem(item, widgetInfo, pageWidgetListIndex)}
            </div>
          ) : null
        )}
      </div>
    </WidgetLayoutContainer>
  );
};

export default RowLayoutWidget;
